import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material'
import React, { useState } from 'react'
import { CollapseIcon } from 'src/mentor/components/ActivityPlanComponent/components/styledComponents'
import { ReportsTableContainer } from '../../styledComponents'

export default function ReportsTableWrapper({
  heading,
  defaultExpanded = false,
  contentIsNotATable = false,
  children,
}) {
  const [expand, setExpand] = useState(defaultExpanded)
  const TableContainer = contentIsNotATable ? React.Fragment : ReportsTableContainer

  return (
    <Accordion elevation={0} expanded={expand} onChange={(e, newValue) => setExpand(newValue)}>
      <AccordionSummary>
        <CollapseIcon collapsed={!expand} />
        <div>{heading && <h5 className="m-0">{heading}</h5>}</div>
      </AccordionSummary>
      <AccordionDetails sx={{ py: 3 }}>
        <TableContainer>{children}</TableContainer>
      </AccordionDetails>
    </Accordion>
  )
}
